export default "__VITE_ASSET__CE1xi_hf__"